'use client'

import { FC } from 'react'
import useI18n from 'Hooks/useI18n'
import { ANNIVERSARY_DEADLINE_TIME } from '@/constant/date'
import GemRewardDisplay from './components/GemRewardDisplay'
import CountdownTimer from './components/CountdownTimer'

const BlackFriBannerCard: FC = () => {
  const { t } = useI18n()

  return (
    <div
      className="relative flex h-full w-full flex-col items-center justify-start bg-cover bg-center px-4"
      style={{
        backgroundImage: 'url(/activity/black_fri.png)',
      }}
    >
      {/* 标题区 */}
      <div className="mb-[20px] mt-[136px] flex flex-col text-center md:mt-[152px]">
        <p className="text-[13px] text-[#FF5079]">
          {/* i18n-ignore */ 'Black Friday '}
        </p>
        <p className="text-[13px] text-[#FF5079]">{t('Monthly Plan Sale')}</p>
        <p className="text-[13px] text-[#FF5079]">{t('Get 4K bonus Gems!')}</p>
      </div>

      {/* 底部容器 - 奖励、倒计时、按钮 */}
      <div className="flex w-full flex-1 flex-col items-center justify-start gap-2">
        {/* 查看按钮 */}
        <div className="w-full">
          <button className="h-[26px] w-full rounded-full bg-[#FF5079] text-[13px] font-medium leading-[26px] text-black hover:bg-white/30">
            {t('View')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default BlackFriBannerCard
